import { render, staticRenderFns } from "./Departures.vue?vue&type=template&id=2c890fd9"
import script from "./Departures.vue?vue&type=script&lang=js"
export * from "./Departures.vue?vue&type=script&lang=js"
import style0 from "./Departures.vue?vue&type=style&index=0&id=2c890fd9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports